<template>
  <div class='xy-content-module'>
    <van-nav-bar fixed>
      <div slot="left" @click="close" class="icon-title-line">
        <van-icon name="arrow-left" color="#333" class="icon-title-size" />
      </div>
      <div slot="title" class="all-title">邀请详情</div>
    </van-nav-bar>
    <div class='xy-content-body'>
        <div class="visit-apply-from"> 
          <van-cell-group>
            <div class="visit-apply-from-list-item">
              <span>邀请主题</span>
              <span>{{vName}}</span>
            </div>
            <div style="width:100%;height:8px;background: #FBF8F9;"></div>
            <div class="visit-apply-from-list-item">
              <span>邀请内容</span>
            </div>
            <p style="padding:0px 16px 14px 16px;color: rgba(0,0,0,.65);word-break: break-all;word-wrap: break-word;">{{vMessage}}</p>
            <div style="width:100%;height:8px;background: #f9f9f9;"></div>
            <div class="visit-apply-from-list-item" style="border-bottom: 1px solid #E5E5E5;">
              <span>到访时间</span>
              <span>{{vIntervieweeTime}}</span>
            </div>
            <div class="visit-apply-from-list-item" style="border-bottom: 1px solid #E5E5E5;">
              <span>地址</span>
              <span>{{vAddress}}</span>
            </div>
            <div class="visit-apply-from-list-item" style="border-bottom: 1px solid #E5E5E5;">
              <span>邀约人</span>
              <span>{{vInvitees}}</span>
            </div>
            <div class="visit-apply-from-list-item">
              <span>邀约日期</span>
              <span>{{xy.moment(visitTime).format('YYYY-MM-DD')}}</span>
            </div>
        </van-cell-group>
        <div class="box-body">
            <div class="box-body-title">
                <span style="color: rgba(0,0,0,0.65);font-weight: 600;">邀请名单</span>
                <span style="color:#1677FF">总数：{{this.vNumber}}人</span>
            </div>
            <div v-for="(item, index) in vInformation" :key="index" class="teachers-show" >
                <div class="teachers-show-item">
                <div class="iconName">
                    <span class="left-span" :style="{background:'#1677FF',color:'#fff'}">{{xy.showName(item.name)}}</span>
                </div>
                <div class="content-text" >
                    <span>{{item.name}}</span>
                    <span>手机号：{{item.phone}}</span>
                </div>
                </div>
            </div>
        </div>
    </div>
    </div>
  </div>
</template>
<script>
  export default {
    name: '',
    data () {
      return {
          vName:'2019级23班家长会',
          vIntervieweeTime:'2020-08-31',
          vMessage:'这里是一个比较长的邀请主题，这里是一个比较长的邀请主题，这里是一个比较长的主题',
          vAddress:'北京市中关村海淀大厦科贸中心B座',
          vInvitees:'张山',
          visitTime:'2020-09-20',
          vNumber:0,
          vInformation:[
              // {name:'啊倒萨',phone:130999998888},
              // {name:'阿萨',phone:130999998888},
              // {name:'撒旦撒旦顶顶',phone:130999998888}
          ],
          invatationInfoID:null,
          launchInvitation:null
      }
    },
    created () {
      if(this.$route.query.invatationInfoID){
        this.invatationInfoID = this.$route.query.invatationInfoID
        this.getDetailInfo()
      }else{
        this.launchInvitation = JSON.parse(localStorage.getItem("launchInvitation"));
        this.vName = this.launchInvitation.InvatationTitle
        this.vIntervieweeTime = this.launchInvitation.InvatationArriveTime
        this.vMessage = this.launchInvitation.InvatationContent
        this.vAddress = this.launchInvitation.InvatationArriveAddress
        this.vInvitees = this.launchInvitation.InvatationUser
        this.visitTime = this.launchInvitation.CreateByDate
        this.vNumber = this.launchInvitation.InvatationUsers.length
        this.vInformation = this.launchInvitation.InvatationUsers.map(item=>{
          return{
                name:item.InvatationFullName,
                phone:item.InvatationPhoneNumber
          }
        })
      }
    },
    mounted () {},
    methods :{
        close(){
          if(this.$route.query.isFrom === 'invitationBuild'){
            this.$router.go(-3);
          }else{
            this.$router.go(-1);
          }
        },
        //详情内容
        async getDetailInfo () {
          let res = await this.xyapi.get(
            this.xyMApi+'/vst' + "/invatation/GetInvatationDetailInfo", { invatationInfoID: this.invatationInfoID }
            //'http://devpczx.xiaoyangedu.net:9092' + '/vst/invatation/GetInvatationDetailInfo', { invatationInfoID: this.invatationInfoID }
          )
          if (res.success) {
            if (res.data !== null) {
              this.detailInfo = res.data
              this.detailListAll = this.detailInfo.invatationDetailInfo ? this.detailInfo.invatationDetailInfo : []
              this.vName = res.data.invatationInfo.InvatationTitle
              this.vIntervieweeTime = res.data.invatationInfo.InvatationArriveTime
              this.vMessage = res.data.invatationInfo.InvatationContent
              this.vAddress = res.data.invatationInfo.InvatationArriveAddress
              this.vInvitees = res.data.invatationInfo.InvatationUser
              this.visitTime = res.data.invatationInfo.CreateByDate
              this.vNumber = res.data.invatationDetailInfo ? res.data.invatationDetailInfo.length : 0
              this.vInformation = this.detailListAll.map(item=>{
                return{
                     name:item.InvatationFullName,
                     phone:item.InvatationPhoneNumber
                }
              })
            }
          } else {
            this.xy.msgError(res.msg)
          }
        },
      }
  }
</script>
<style lang='less' scoped>
.visit-apply-from-list-item{
  padding:24px 34px;
  display: flex;
  height: auto;
  span:nth-child(1){
    display: inline-block;
    width: 180px;
    color: rgba(0,0,0,0.85);
  }
  span:nth-child(2){
    display: inline-block;
    color: rgba(0,0,0,0.65);
    width: 100%;
    word-break: break-all;
    word-wrap: break-word;
  }
}
.box-body{
  width:100%;
  height: 880px;
  overflow: auto;
  margin-top: 16px;
  background: #ffffff;
  .box-body-title{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding:24px 34px;
      border-bottom: 1px solid #E5E5E5;
  }
  .teachers-show{
    width:100%;
    height:110px;
    padding:0px 0px 0px 30px;
    margin-top: 30px;
    // margin-bottom: 33px;
    .teachers-show-item{
      width:100%;
      height:100%;
      border-bottom: 1px dashed #E5E5E5;
      .iconName{
        float:left;
        .left-span{
          display: inline-block;
          width: 78px;
          height: 78px;
          border-radius:50%;
          line-height:74px;
          text-align:center;
          color:#fff;
        }
      }
      .content-text{
        float:left;
        display: flex;
        flex-direction: column;
        margin: 0 22px;
        flex: 6;
        margin-bottom: 4px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        span:nth-child(1){
          display: inline-block;
          margin-top: -4px;
          color: rgba(0, 0, 0, 0.85);
        }
        span:nth-child(2){
          display: inline-block;
          margin-top: 4px;
          color: rgba(0, 0, 0, 0.65);
        }
      }
    }
  }
}
.icon-title-line{
  display: flex;
  align-items: center;
}
.icon-title-size{
  font-size: 38px;
}
 /deep/ .van-dialog__footer{
  display: none;
}
</style>
